import { Route, createRoutesFromElements } from 'react-router-dom';
import { Suspense } from 'react';
import { Layout } from 'es/app/components/layout';
import ApplicationToaster from 'es/app/components/layout/ApplicationToaster';
import Protected from 'es/app/security/protected';
import IconLibrary from 'es/app/visuals/IconLibrary';
import Throbber from 'es/app/components/progress-indicators/Throbber';

import { AccessGroupRoutes } from 'es/app/components/layout/routes/AccessGroupRoutes';
import { AlertRoutes } from 'es/app/components/layout/routes/AlertRoutes';
import { DataImporterRoutes } from 'es/app/components/layout/routes/DataImporterRoutes';
import { EmissionSourceRoutes } from 'es/app/components/layout/routes/EmissionSourceRoutes';
import { FacilityRoutes } from 'es/app/components/layout/routes/FacilityRoutes';
import { FileRoutes } from 'es/app/components/layout/routes/FileRoutes';
import { LibraryRoutes } from 'es/app/components/layout/routes/LibraryRoutes';
import { ModelRoutes } from 'es/app/components/layout/routes/ModelRoutes';
import { PeopleRoutes } from 'es/app/components/layout/routes/PeopleRoutes';
import { ProcessRoutes } from 'es/app/components/layout/routes/ProcessRoutes';
import { ReportRoutes } from 'es/app/components/layout/routes/ReportRoutes';
import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SequenceRoutes } from 'es/app/components/layout/routes/SequenceRoutes';
import { TemporalThresholdRoutes } from 'es/app/components/layout/routes/TemporalThresholdRoutes';
import { SsoUserTemplateRoutes } from 'es/app/components/layout/routes/SsoUserTemplateRoutes';

export const ROUTES = createRoutesFromElements(
    <>
        <Route
            path="/"
            element={
                <Suspense fallback={<Throbber text="..." />}>
                    <Protected>
                        <IconLibrary />
                        <Layout />
                        <ApplicationToaster />
                    </Protected>
                </Suspense>
            }
            ErrorBoundary={RouteErrorBoundary}
        >
            {/**
             * Routes need to be called as functions to prevent this error:
             * [SomeRoute] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>
             */}
            {AccessGroupRoutes()}
            {AlertRoutes()}
            {DataImporterRoutes()}
            {EmissionSourceRoutes()}
            {FacilityRoutes()}
            {FileRoutes()}
            {LibraryRoutes()}
            {ModelRoutes()}
            {PeopleRoutes()}
            {ProcessRoutes()}
            {ReportRoutes()}
            {SequenceRoutes()}
            {SsoUserTemplateRoutes()}
            {TemporalThresholdRoutes()}
        </Route>
    </>
);
